import { render, staticRenderFns } from "./ProjectRealEstateAgentbox.vue?vue&type=template&id=43abd631"
import script from "./ProjectRealEstateAgentbox.vue?vue&type=script&lang=ts"
export * from "./ProjectRealEstateAgentbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports